module.exports = __webpack_public_path__ + "img/xinjian2.8f060afa.svg";